



















import { Component, Prop, Vue, Emit, Watch, Ref } from 'vue-property-decorator';
import { checkAmountInput, parseAmount } from './business';
import { amount } from '@tencent/wphk-base-utils';
import { KeyboardInput } from '@tencent/wphk-ui';

/**
 * 金额输入框
 * 金额的输入输出单位都是（分）
 */
@Component({
  components: {
    KeyboardInput,
  },
})
export default class AmountInput extends Vue {
  /**
   * 金额（分）
   */
  @Prop({ default: 0 }) public value!: number;

  /**
   * 币种
   */
  @Prop({ default: 'HK$' }) public currencyCode!: string;

  /**
   * 输入提示文案
   */
  @Prop({ default: '0.00' }) public placeholder!: string;

  /**
   * 输入提示语位置，在光标左侧还是右侧
   */
  @Prop({ default: 'right' }) public placeholderPos!: 'left' | 'right';

  /**
   * 是否禁用金额输入
   */
  @Prop({ default: false }) public disabled!: boolean;

  /**
   * 光标输入组件
   */
  @Ref('input') public inputEl!: KeyboardInput;

  /**
   * 光标聚焦标识
   */
  public isFocus = false;

  /**
   * 输入的金额信息（单位元）
   */
  public inputedValue = '';

  @Watch('value')
  public watchAmountPropChanged(value: number) {
    if (value) {
      const val = amount.fen2Yuan(value.toString());
      this.setValue(val);
    }
  }

  /**
   * 输入前的检测
   * 检测输入的字符是否可以组成有效金额
   * @param newVal 输入后的金额字符串
   * @param value  输入前的金额字符串
   * @param char 当前输入前的字符
   */
  public beforeInput(newVal: string) {
    return checkAmountInput(newVal);
  }

  /**
   * 光标输入
   */
  public handleFocus() {
    this.isFocus = true;
  }

  /**
   * 光标离开
   */
  public handleBlur() {
    this.isFocus = false;
    // 光标离开时格式化下金额
    // 对于格式后的金额为0的情况，需清空输入框
    this.setValue(this.inputedValue);
  }

  /**
   * 金额输入后格式化数据，并返回金额数字（分）给调用方
   * @param value
   */
  @Emit('input')
  public handleInput(value: string, isDelete: boolean) {
    const amountValue = parseAmount(value);
    this.inputedValue = amountValue;
    this.fixInput(amountValue, value, isDelete);
    // 返回单位为分的数字金额值
    return amountValue ? amount.yuan2fen(amountValue) : 0;
  }

  /**
   * 点击币种后光标聚焦
   */
  public handlePrefixClick() {
    this.setFocus();
    // 光标置于起始位置
    this.inputEl.setCursorPos(0);
  }

  /**
   * 修正输入框中金额内容
   * @param prasedValue
   * @param value
   * @param isDelete
   */
  public fixInput(prasedValue: string, value: string, isDelete: boolean) {
    if (prasedValue !== value) {
      if (!isDelete) {
        // 字符输入的情况下，如果格式化后的金额与输入的不一致，则更新格式化后的内容到输入框中
        this.setValue(prasedValue, false);
      }
    }
  }

  /**
   * 设置光标自动接入
   */
  public setFocus() {
    this.inputEl.focus();
  }

  /**
   * 设置金额(元)
   * @param value 当前金额字符串
   * @param needUpdate 是否需要更新最终金额值
   */
  private setValue(value: string, needUpdate = true) {
    if (needUpdate) {
      const fen = amount.yuan2fen(value || '');
      // 分元转换，主要是为了获取格式化后的金额字符串
      this.inputedValue = fen > 0  ? amount.fen2Yuan(fen.toString()) : '';
    }
    this.inputEl?.setValue(this.inputedValue);
  }

  private mounted() {
    if (this.value) {
      const val = amount.fen2Yuan(this.value.toString());
      this.setValue(val);
    }
  }
}
